export default {
    'PRIMARY_LOCATION' : 'pl', 
    'RADIUS' : 'r', 
    'JOB_TYPE' : 'jt', 
    'LOCATION' : 'l', 
    'COMPANIES' : 'c', 
    'CATEGORIES' : 'ct', 
    'KEYWORD' : 'kw',
    'EXPERIENCE' : 'exp'
}